<template>
    <div>
        <dx-grid
            url="messages"
            :baseUrl="getBaseUrl()"
            name="wer-messages"
            :columns="columns"
            title="Messages"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :onLoaded="onLoaded"
        ></dx-grid>
        <v-dialog v-model="newMessageDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">New Message</div>

                <v-btn
                    small
                    class="mr-2 mt-4"
                    outline
                    color="success"
                    :loading="uploading"
                    @click="pickFile()"
                >
                    Upload
                    <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".mp3"
                    @change="onFilePicked($event)"
                />
                <div v-if="files.length" class="mt-0 ml-2 mb-2">
                    {{ files[0].name }}
                </div>
                <audio
                    class="mt-2 mb-3"
                    v-if="newMessage.recordingURL"
                    controls
                    ref="recordingURL"
                    :src="newMessage.recordingURL"
                ></audio>
                <v-text-field
                    class="mt-2 mb-3"
                    v-model="newMessage.phone"
                    hide-details
                    label="From Phone"
                ></v-text-field>
                <v-textarea
                    class="mt-2 mb-3"
                    v-model="newMessage.subject"
                    rows="2"
                    outline
                    hide-details
                    label="Subject"
                ></v-textarea>
                <v-btn
                    class="mt-0 mb-3 py-0"
                    small
                    :disabled="!newMessage.subject"
                    @click="playText(newMessage.subject)"
                    color="info"
                >
                    Play
                </v-btn>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="newMessageDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="sending"
                        @click="sendNewMessage"
                        >Send Message</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="textMessageDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">Text Message</div>

                <v-btn
                    small
                    class="mr-2 mt-4"
                    outline
                    color="success"
                    :loading="uploading"
                    @click="pickTextMessageFile()"
                >
                    Upload
                    <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
                <input
                    type="file"
                    style="display: none"
                    ref="textMessageFiles"
                    accept=".mp3"
                    @change="onTextMessageFilePicked($event)"
                />
                <div v-if="textMessageFiles.length" class="mt-0 ml-2 mb-2">
                    {{ textMessageFiles[0].name }}
                </div>
                <v-text-field
                    class="mt-2 mb-3"
                    v-model="textMessage.phone"
                    hide-details
                    label="From Phone"
                ></v-text-field>
                <v-textarea
                    class="mt-2 mb-3"
                    v-model="textMessage.text"
                    rows="8"
                    outline
                    hide-details
                    label="Text"
                    ref="textMessageText"
                ></v-textarea>
                <img
                    class="mb-3"
                    v-if="textMessage.imageUrl"
                    :src="textMessage.imageUrl"
                    style="width: 100%;"
                />
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="textMessageDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="sending"
                        :disabled="!textMessage.text"
                        @click="sendTextMessage"
                        >Send Message</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteMessagesDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">Delete Messages</div>
                <div class="my-3">
                    This will delete {{ selected.length }} messages
                </div>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteMessagesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="deleteMessages"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewMessageDialog" max-width="900">
            <v-card class="pa-4">
                <v-progress-linear
                    v-if="loading"
                    :indeterminate="true"
                    color="success"
                    style="width: 70%;"
                    class="mx-1"
                ></v-progress-linear>
                <div
                    class="my-3 mx-1 pa-2"
                    style="border: 2px solid #43a047; width: 70%;"
                    v-if="!loading"
                >
                    <div v-for="(info, index) in clickedMessage.listeners">
                        <v-layout row>
                            <div
                                style="width: 200px"
                                class="font-weight-medium"
                            >
                                {{ info.name }}
                            </div>
                            <div style="width: 120px">{{ info.time }}</div>
                            <div>{{ info.lastTime }}</div> </v-layout
                        ><v-divider
                            class="mb-2 mt-1"
                            v-if="index + 1 < clickedMessage.listeners.length"
                        ></v-divider>
                    </div>
                    <v-divider class="mt-2"></v-divider>
                </div>
                <div
                    class="my-3 mx-1 pa-2"
                    style="border: 2px solid #43a047; width: 70%;"
                >
                    <v-btn
                        small
                        class="mr-2 mt-2"
                        outline
                        color="success"
                        :loading="uploading"
                        @click="pickClickedMessageFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="clickedMessageFiles"
                        accept=".mp3"
                        @change="onClickedMessageFilePicked($event)"
                    />
                    <div
                        v-if="clickedMessage && clickedMessage.files.length"
                        class="mt-0 ml-2 mb-2"
                    >
                        {{ clickedMessage.files[0].name }}
                    </div>
                    <audio
                        class="mt-2 mb-3"
                        v-if="clickedMessage.newRecordingURL"
                        controls
                        ref="newRecordingURL"
                        :src="clickedMessage.newRecordingURL"
                    ></audio>
                    <v-card-actions class="mr-0 ml-0 mt-0">
                        <v-btn
                            color="success"
                            :loading="updating"
                            small
                            @click="updateMessage"
                            >Update Message</v-btn
                        >
                        <v-btn
                            color="success"
                            class="ml-2"
                            small
                            :disabled="!clickedMessage"
                            @click="openMessageInterviewDialog(clickedMessage)"
                            >Add Message To Interview Section</v-btn
                        >
                    </v-card-actions>
                </div>

                <pre>{{ viewMessageText | pretty }}</pre>
                <v-card-actions>
                    <v-btn @click="viewMessageDialog = false" color="#999" dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateInterviewMessagesDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">Add To Interview Section</div>
                <div class="my-3 font-weight-medium">
                    This message will be added to the interview section at #3-3
                </div>
                <v-layout row>
                    <div class="font-weight-medium mr-2">Date:</div>
                    {{ clickedMessage.date | date }}</v-layout
                ><v-layout row>
                    <div class="font-weight-medium mr-2 mb-2">Name:</div>
                    {{ clickedMessage.senderName }}</v-layout
                >
                <audio
                    class="mt-2 mb-3"
                    v-if="clickedMessage.recordingUrl"
                    controls
                    ref="recordingURL"
                    :src="clickedMessage.recordingUrl"
                ></audio>
                <v-textarea
                    class="mt-2 mb-3"
                    label="Interview Subject"
                    v-model="interviewMessageSubject"
                    rows="2"
                    outline
                    hide-details
                ></v-textarea>
                <v-btn
                    class="mt-0 mb-3 py-0"
                    small
                    :disabled="!interviewMessageSubject"
                    @click="playText(interviewMessageSubject)"
                    color="info"
                >
                    Play
                </v-btn>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateInterviewMessagesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveInterviewMessage"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="playlistDialog" max-width="600">
            <v-card class="pa-3">
                <div class="headline">Save Messages To Playlist</div>
                <div class="my-3">
                    This will save the {{ selected.length }} selected messages
                    into the playlist
                </div>
                <div style="overflow-y: auto; height: 350px">
                    <div v-for="(message, index) in selected">
                        <div class="font-weight-medium">
                            {{ formatDate(message.date) }}
                        </div>
                        <div class="mb-2">
                            {{
                                message.senderName + " - " + message.senderPhone
                            }}
                        </div>
                        <audio :src="message.recordingUrl" controls></audio>
                        <v-divider
                            class="my-2"
                            v-if="index + 1 < selected.length"
                        ></v-divider>
                    </div>
                </div>
                <v-text-field
                    v-model="playlistCallerID"
                    label="Caller ID"
                    hide-details
                    style="width: 300px;"
                    class="mb-2"
                ></v-text-field>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="playlistDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        :disabled="invalidPhone(playlistCallerID)"
                        @click="saveToPlaylist"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ky from "ky";
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";
import AWS from "aws-sdk";

export default {
    data() {
        return {
            title: "Credit",
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            isMobile: false,
            selected: [],

            headers: [
                { value: "Status", text: "Status" },
                { value: "Timestamp", text: "Timestamp" },
                { value: "SenderName", text: "Sender" },
                { value: "SenderPhone", text: "Sender Phone" },
                { value: "RecordingURL", text: "Recording" },
                { value: "OriginalRecordingURL", text: "Original" },
                { value: "phoneNumberList", text: "Sent To" },
            ],

            messages: [],

            viewMessageDialog: false,
            updateInterviewMessagesDialog: false,
            interviewMessageSubject: "",
            loading: false,
            viewMessageText: "",
            clickedMessage: "",

            newMessageDialog: false,
            textMessageDialog: false,

            deleteMessagesDialog: false,
            updating: false,
            uploading: false,
            sending: false,
            processing: false,
            files: [],
            textMessageFiles: [],

            playlistDialog: false,
            playlistCallerID: "",

            newMessage: {
                recordingURL: "",
                subject: "",
                phone: "13479710707",
            },

            textMessage: {
                imageUrl: "",
                phone: "13479710707",
            },

            awsPolly: "",
            actions: [],
            intervalID: "",

            columns: [
                {
                    field: "Status",
                    isIcon: true,
                    template: "icon",
                    alignment: "center",
                    visible: true,
                    allowFiltering: false,
                    allowHeaderFiltering: false,
                    allowHiding: false,
                    allowSearch: false,
                    cssClass: "width-25",
                    headerFilter: {
                        allowSearch: false,
                        groupInterval: undefined,
                        height: undefined,
                        searchMode: "contains",
                        width: undefined,
                    },
                    icon: (value) => {
                        switch (value) {
                            case "Completed":
                                return "mdi-check-circle";
                            case "InProgress":
                            case "Queued":
                                return "mdi-progress-upload";
                            case "Pending":
                                return "mdi-clock";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value) => {
                        switch (value) {
                            case "Completed":
                                return "success";
                            case "InProgress":
                            case "Queued":
                                return "#42A5F5";
                            case "Pending":
                                return "#fdb400";
                            default:
                                return "#aeb8bf";
                        }
                    },
                },
                {
                    field: "SenderName",
                    label: "Name",
                    format: "",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "SenderPhone",
                    label: "From Phone",
                    format: "",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "Date",
                    label: "Date",
                    type: "date",
                    format: "",
                    visible: true,
                    filterType: "",
                    format: "MM/dd/yyyy hh:mm:ss a",
                    sortOrder: "desc",
                    sortIndex: 0,
                    filterValues: [],
                    filterValue: new Date(
                        moment()
                            .subtract(30, "day")
                            .add(1, "day"),
                    ),
                    selectedFilterOperation: ">=",
                },
                {
                    field: "RecordingUrl",
                    label: "Recording",
                    format: "",
                    template: "link-audio-cell-template",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "SubjectUrl",
                    label: "Subject",
                    format: "",
                    template: "link-audio-cell-template",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "Parts",
                    label: "Parts",
                    type: "number",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "Status",
                    label: "Status",
                    format: "",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "FormattedDuration",
                    label: "Duration",
                    format: "",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },

                {
                    field: "Type",
                    label: "Type",
                    format: "",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
                {
                    field: "State",
                    label: "Interview Subject",
                    format: "",
                    visible: true,
                    filterType: "",
                    filterValues: [],
                    filterValue: null,
                    selectedFilterOperation: null,
                },
            ],
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
        date: function(value) {
            if (value) {
                return moment(value).format("MM/DD/YYYY h:mm:ss A");
            }
        },
    },
    mounted() {
        this.awsPolly = new AWS.Polly({
            accessKeyId: "AKIA3LKZMVJXVMXC6IK6",
            secretAccessKey: "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",
            region: "us-east-1",
        });

        this.intervalID = setInterval(() => {
            if (this.$refs && this.$refs.grid) {
                this.$refs.grid.reloadGrid();
            }
        }, 300000);
    },
    created() {
        //this.firebaseSetup();
        //this.loadAccount();
        //this.loadData();
        this.isMobile = window.innerWidth < 551;

        this.actions.push({
            action: this.openTextMessageDialog,
            text: "Text Message",
        });

        this.actions.push({
            action: this.openNewMessageDialog,
            text: "New Message",
        });

        this.actions.push({
            action: this.openDeleteMessages,
            showOnSelection: true,
            text: "Delete Messages",
        });

        this.actions.push({
            action: this.openPlaylistDialog,
            showOnSelection: true,
            text: "Save To Playlist",
        });

        this.setTextMessagePhone();

        window.addEventListener("paste", (e) => {
            if (this.textMessageDialog) {
                this.$refs.textMessageFiles.files = e.clipboardData.files;
                this.textMessageFiles = e.clipboardData.files;

                this.uploadTextMessageFile(e.clipboardData.files);
            }
        });
    },
    beforeDestroy() {
        clearInterval(this.intervalID);
    },
    methods: {
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("messages");

            const messagesRef = ref.orderByKey().limitToLast(100);

            messagesRef.on(
                "value",
                (snapshot) => {
                    const messages = Object.values(snapshot.val()).map(
                        (message) => {
                            message.SenderPhone = this.formatPhoneNumber(
                                message.SenderPhone,
                            );

                            message.PhoneNumberList = message.PhoneNumbers.map(
                                (m) => this.formatPhoneNumber(m.Phone),
                            ).join(",");

                            message.Date = moment(message.Timestamp).format(
                                "LLL",
                            );

                            return message;
                        },
                    );
                    this.messages = messages.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.pagination.totalItems = this.messages.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );

            ref.on("child_added", (data, prevChildKey) => {
                // const message = data.val();
                // message.SenderPhone = this.formatPhoneNumber(
                //     message.SenderPhone
                // );
                // message.PhoneNumberList = message.PhoneNumbers.map(m =>
                //     this.formatPhoneNumber(m.Phone)
                // ).join(",");
                // message.Timestamp = moment(message.Timestamp).format("LLL");
                // this.messages.push(message);
            });

            // ref.on("child_changed", function(data, prevChildKey) {
            //     console.log(data.val());
            // });

            var accountRef = firebase.database().ref("account");

            const accounts = accountRef.orderByKey().limitToLast(1);

            accounts.on(
                "value",
                (snapshot) => {
                    const accountInfo = Object.values(snapshot.val()).map(
                        (account) => {
                            this.title =
                                "Credit: $" + account.Credit.toFixed(2);

                            return account;
                        },
                    );
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        openMessageInterviewDialog() {
            this.updateInterviewMessagesDialog = true;
        },
        getLastMessages() {
            return this.messages.slice(0, 30);
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        getBaseUrl() {
            return window.location.origin.startsWith("http://localhost")
                ? "https://localhost:5001"
                : "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app";
        },
        async loadData() {
            const messages = await ky("api/home/getMessages", {
                prefixUrl: this.getDomain(),
            }).json();

            this.pagination.totalItems = messages.length;
            this.messages = messages;
        },
        async loadAccount() {
            const account = await ky("api/home/getAccount", {
                prefixUrl: this.getDomain(),
            }).json();

            const credit = +JSON.parse(account).cash_credits;

            this.title = "Credit: $" + credit.toFixed(2);
        },
        getDomain() {
            return window.location.host.includes("localhost")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "InProgress":
                case "Queued":
                    return "mdi-progress-upload";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "InProgress":
                case "Queued":
                    return "#42A5F5";
                case "Pending":
                    return "#fdb400";
            }
        },
        onRowClicked(row) {
            const message = JSON.parse(JSON.stringify(row));

            //message.recordingURL = message.recordingURL;

            this.viewMessage(message);
        },
        // onLoaded(result) {
        //     result = result.map((r) => {
        //         return this.parsePascalCaseToCamelCase(r);
        //     });
        //     console.log(result);
        // },
        async viewMessage(message) {
            this.clickedMessage = message;
            this.clickedMessage.files = [];
            this.viewMessageDialog = true;

            this.viewMessageText = message;

            try {
                this.loading = true;

                const url =
                    this.getDomain() +
                    "/api/broadcast/GetListenersSql?recordingURL=" +
                    message.RecordingUrl;

                const response = await this.$http.get(url);

                this.clickedMessage.listeners = response.data.listeners.map(
                    (listener) => {
                        listener.lastTime = moment(listener.lastTime).format(
                            "MM/DD/YYYY h:mm:ss A",
                        );

                        return listener;
                    },
                );

                //this.clickedMessage = message;
                this.clickedMessage.newRecordingURL = "";

                this.viewMessageText = this.clickedMessage;

                console.log(JSON.stringify(this.clickedMessage, null, 2));

                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        openNewMessageDialog() {
            const user = this.$store.state.user;

            switch (user.toLowerCase()) {
                case "aronyakov":
                    this.newMessage.phone = "13474366239";
                    break;
                case "saul":
                    this.newMessage.phone = "19176856104";
                    break;
                case "tatty":
                    this.newMessage.phone = "17185706574";
                    break;
                case "yakov":
                    this.newMessage.phone = "13475540115";
                    break;
                default:
                    break;
            }

            this.newMessageDialog = true;
        },
        setTextMessagePhone() {
            const user = this.$store.state.user;

            switch (user.toLowerCase()) {
                case "aronyakov":
                    this.textMessage.phone = "13474366239";
                    break;
                case "saul":
                    this.textMessage.phone = "19176856104";
                    break;
                case "tatty":
                    this.textMessage.phone = "17185706574";
                    break;
                case "yakov":
                    this.textMessage.phone = "13475540115";
                    break;
                default:
                    break;
            }
        },
        openTextMessageDialog() {
            this.textMessageDialog = true;
        },
        openDeleteMessages() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.deleteMessagesDialog = true;
        },
        async deleteMessages() {
            try {
                this.processing = true;

                await this.$http.post(
                    this.getDomain() + "/api/broadcast/deleteMessages",
                    this.selected.map((s) => s.RecordingUrl),
                );

                this.processing = false;
                this.deleteMessagesDialog = false;
                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveInterviewMessage() {
            if (!this.interviewMessageSubject) return;

            try {
                this.processing = true;

                await this.$http.post(
                    this.getDomain() +
                        "/api/broadcast/UpdateInterviewMessage?originalURL=" +
                        this.clickedMessage.RecordingUrl +
                        "&subject=" +
                        this.interviewMessageSubject,
                );

                this.processing = false;
                this.updateInterviewMessagesDialog = false;
                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        pickClickedMessageFile() {
            this.$refs.clickedMessageFiles.click();
        },
        async onClickedMessageFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.clickedMessage.files = files;

            var formData = new FormData();

            formData.append("file", files[0]);

            try {
                const response = await this.$http.post(
                    this.getDomain() + "/api/home/GetUrl?type=message",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.clickedMessage.newRecordingURL = response.data;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async updateMessage() {
            if (!this.$refs.newRecordingURL) return;

            this.updating = true;

            try {
                await this.$http.post(
                    this.getDomain() +
                        "/api/broadcast/updateMessageSpeed?originalRecordingUrl=" +
                        this.clickedMessage.RecordingUrl +
                        "&newRecordingUrl=" +
                        this.clickedMessage.newRecordingURL,
                );

                this.updating = false;
                this.viewMessageDialog = false;

                this.clickedMessage.files = [];
                this.clickedMessage.newRecordingUrl = "";
            } catch (e) {
                this.sending = false;
            }
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            var formData = new FormData();

            formData.append("file", files[0]);

            try {
                const response = await this.$http.post(
                    this.getDomain() + "/api/home/GetUrl?type=greeting",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.newMessage.recordingURL = response.data;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        pickTextMessageFile() {
            this.$refs.textMessageFiles.click();
        },
        async onTextMessageFilePicked(e) {
            this.uploading = true;

            const textMessageFiles = e.target.files;

            if (!textMessageFiles) return;

            this.textMessageFiles = textMessageFiles;

            this.uploadTextMessageFile(textMessageFiles);
        },
        async uploadTextMessageFile(files) {
            var formData = new FormData();

            formData.append("file", files[0]);

            try {
                const response = await this.$http.post(
                    this.getDomain() + "/api/home/GetImageUrl?type=greeting",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.textMessage.imageUrl = response.data;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async sendTextMessage() {
            // if (!this.$refs.recordingURL || !this.$refs.recordingURL.duration)
            //     return;

            this.sending = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/broadcast/sendTextMessage",
                    {
                        urls: this.textMessage.imageUrl,
                        to: this.textMessage.phone,
                        text: this.textMessage.text,
                    },
                );

                this.sending = false;
                this.textMessageFiles = [];
                this.$refs.textMessageFiles.value = null;
                this.textMessageDialog = false;

                this.textMessage.imageUrl = "";
                this.textMessage.text = "";
            } catch (e) {
                this.sending = false;
            }
        },
        async sendNewMessage() {
            if (!this.$refs.recordingURL || !this.$refs.recordingURL.duration)
                return;

            this.sending = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/broadcast/sendMessageAsQueued",
                    {
                        recordingURL: this.newMessage.recordingURL,
                        subject: this.newMessage.subject,
                        phone: this.newMessage.phone,
                        recordingDuration: this.$refs.recordingURL.duration,
                    },
                );

                this.sending = false;
                this.newMessageDialog = false;

                this.newMessage.recordingURL = "";
                this.newMessage.subject = "";
            } catch (e) {
                this.sending = false;
            }
        },
        openPlaylistDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.playlistDialog = true;
        },
        async saveToPlaylist() {
            const phone =
                this.playlistCallerID && this.playlistCallerID.length < 11
                    ? "1" + this.playlistCallerID
                    : this.playlistCallerID;

            this.processing = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/playlist/saveMessagesToPlaylist",
                    {
                        ids: this.selected.map((i) => i.Id),
                        callerID: phone,
                    },
                );

                this.processing = false;
                this.playlistDialog = false;

                this.playlistCallerID = "";
            } catch (e) {
                this.sending = false;
            }
        },
        formatDate(date) {
            if (!date) return;

            return moment(date).format("L");
        },
        invalidPhone(phone) {
            var numbersOnly = phone.replace(/\D/g, "");

            return numbersOnly.length < 10 || numbersOnly.length > 11;
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
.width-25 {
    width: 25px !important;
    min-width: 25px !important;
    max-width: 25px !important;
}
</style>
